import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { LearnerEISAUploadForm } from './LearnerEISAUploadForm';
import DocumentUpload from '../../widgets/DocumentUpload';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import AlertItem from "../../widgets/AlertItem";
import ViewUtils from '../../ViewUtils';


const utils = new ViewUtils();

export default function LearnerEISAUploadDialog(props) {

    const [open, setOpen] = React.useState(props.open);
    const [AddDiasbaled, setAddDiasbaled] = React.useState(true);
    const [Message, setMessage] = React.useState("");
    const [MessageStyle, setMessageStyle] = React.useState("");
    const formRef = React.createRef();
    const [filename, setFilename] = React.useState("");
    const [size, setSize] = React.useState(null);
    const [base64, setBase64] = React.useState(null);
    const [type, setType] = React.useState(null);

    const [filenameSOR, setFilenameSOR] = React.useState("");
    const [sizeSOR, setSizeSOR] = React.useState(null);
    const [base64SOR, setBase64SOR] = React.useState(null);
    const [typeSOR, setTypeSOR] = React.useState(null);

    const [filenameSOWE, setFilenameSOWE] = React.useState("");
    const [sizeSOWE, setSizeSOWE] = React.useState(null);
    const [base64SOWE, setBase64SOWE] = React.useState(null);
    const [typeSOWE, setTypeSOWE] = React.useState(null);

    const [model, setModel] = React.useState({
        TrancheID: null
    });
    const [clearOptions, setClearOptions] = React.useState(false);

    const handleClose = (cancel, save, response) => {
        setFilename("");
        setOpen(false);
        props.closeHandler(cancel, save, response);
    };

    const cancel = () => {
        handleClose(true, false);
    };

    const add = () => {
        let formValue = formRef.current.getValue();
        formValue.FLCDocument = {};
        formValue.FLCDocument.Name = filename;
        formValue.FLCDocument.size = size;
        formValue.FLCDocument.type = type;
        formValue.FLCDocument.base64 = base64;
        formValue.LearnerQCTOLearnershipID = props.LearnerQCTOLearnershipID;
        formValue.SORDocument = {};
        formValue.SORDocument.Name = filenameSOR;
        formValue.SORDocument.size = sizeSOR;
        formValue.SORDocument.type = typeSOR;
        formValue.SORDocument.base64 = base64SOR;
        formValue.SOWEDocument = {};
        formValue.SOWEDocument.Name = filenameSOWE;
        formValue.SOWEDocument.size = sizeSOWE;
        formValue.SOWEDocument.type = typeSOWE;
        formValue.SOWEDocument.base64 = base64SOWE;

        if (formValue !== null && typeof formValue !== 'undefined') {

            const url = `api/sims/LearnerEISAReadiness/addLearnerEISAReadiness`;

            utils.invokeUrl(url, (response) => {
                handleClose(false, true, response);
            }, () => { handleClose(false, false); },
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': "Bearer " + localStorage.getItem("token")
                    },
                    body: JSON.stringify(formValue)
                }
            );
        }
    }

    const onUploadHandler = (data) => {
        if (data) {
            setFilename(data.name);
            setSize(data.size);
            setBase64(data.base64);
            setType(data.type);
        }
    }

    const onUploadHandlerSOR = (data) => {
        if (data) {
            setFilenameSOR(data.name);
            setSizeSOR(data.size);
            setBase64SOR(data.base64);
            setTypeSOR(data.type);
        }
    }

    const onUploadHandlerSOWE = (data) => {
        if (data) {
            setFilenameSOWE(data.name);
            setSizeSOWE(data.size);
            setBase64SOWE(data.base64);
            setTypeSOWE(data.type);
            setAddDiasbaled(false);
        }
    }

    const clearOptionsHandler = () => {
        setClearOptions(false);
    }


    React.useEffect(() => {
        setOpen(props.open);
    }, [props.open]);

    return (
        <div className="w-100 lookup">
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="md" disableBackdropClick={true}>
                <div style={{ padding: "32px" }}>
                    <p className="legend">
                        EISA Readiness
                    </p>

                    <div style={{ paddingLeft: "24px", paddingRight: "44px" }}>
                        <AlertItem message={Message} alertStyle={MessageStyle} />
                    </div>

                    <div style={{ height: "90%" }}>
                        <LearnerEISAUploadForm ref={formRef} className="h-100"
                            clearOptions={clearOptions}
                            clearOptionsHandler={clearOptionsHandler}
                            model={model}
                            data={model}/>


                        <DocumentUpload id={"flc"} buttonLabel={"FLC Document"} showViewer={false} onUploadHandler={onUploadHandler} filename={filename} />

                        <DocumentUpload id={"SOWE"} required buttonLabel={"SOR Document"} showViewer={false} onUploadHandler={onUploadHandlerSOR} filename={filenameSOR} />

                        <DocumentUpload id={"sowe"} required buttonLabel={"Statement of Work Experience Document"} showViewer={false} onUploadHandler={onUploadHandlerSOWE} filename={filenameSOWE} />
                    </div>
                    <DialogActions>
                        <Button onClick={add} color="primary" disabled={AddDiasbaled}>
                            Save
                        </Button>
                        <Button onClick={cancel} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </div>
            </Dialog>
        </div>
    );
}
